enum Role {
    STORE_ADMIN = 'Store Admin',
    STORE_USER = 'Store User',
    GLS_S2S_ADMIN = 'GLS S2S Admin',
    GLS_ADMIN = 'GLS Admin',
    PICK_USER = 'Pick User',
    WEB_USER = 'Web User'
}

export { Role };
